/**
 * OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPage
 *
 * Page component for OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPage
 * Path: /docs/tutorials/beginner/complete-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView as __OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView';
import { OrbDocTutorialsBeginnerCompleteOrbitalENDocAnalyticsView as __OrbDocTutorialsBeginnerCompleteOrbitalENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPage(_props: OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Build a complete orbital","description":"Build an expense approval flow from one state to four, with a guard that enforces a spending rule.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/complete-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/complete-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/complete-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerCompleteOrbitalENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalENOrbDocTutorialsBeginnerCompleteOrbitalENPage;
